import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const HillClimbOrDescentIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Hill climb/descent - steep incline with arrows */}
    <path d="M4 20L20 4" />
    <path d="M4 20h6" />
    <path d="M4 20v-6" />
    <path d="M17 7l3-3-3 0" />
    <path d="M20 4v3" />
  </svg>
);
